export var createCsatSettingsApi = function (baseUrl, http) {
    var csatSettingsUrl = "".concat(baseUrl, "/csat");
    var csatServerUrl = "/apps/survey";
    var getLocaleUrl = function (locale) { return "".concat(csatSettingsUrl, "/").concat(locale); };
    return {
        getGeneralSettings: function () { return http.get(csatSettingsUrl); },
        enableLocale: function (locale) { return http.put("".concat(getLocaleUrl(locale), "/enable"), {}); },
        disableLocale: function (locale) { return http.put("".concat(getLocaleUrl(locale), "/disable"), {}); },
        setCsatDelay: function (delayMinutes) { return http.put("".concat(csatSettingsUrl, "/delay"), { delayMinutes: delayMinutes }); },
        setCsatThrottling: function (throttlingMinutes) { return http.put("".concat(csatSettingsUrl, "/throttling"), { throttlingMinutes: throttlingMinutes }); },
        setCsatConditions: function (dto) { return http.put("".concat(csatSettingsUrl, "/conditions"), dto); },
        setDisableMultipleCsatsPerTicket: function (enabled) { return http.put("".concat(csatSettingsUrl, "/multipleCsats/enable"), { enabled: enabled }); },
        getLocaleSettings: function (locale) { return http.get(getLocaleUrl(locale)); },
        enableChannel: function (locale, channel) {
            return http.put("".concat(getLocaleUrl(locale), "/channel/enable"), { channel: channel, enabled: true });
        },
        disableChannel: function (locale, channel) {
            return http.put("".concat(getLocaleUrl(locale), "/channel/enable"), { channel: channel, enabled: false });
        },
        setInvitationMessage: function (locale, channel, invitationMessage) {
            return http.put("".concat(getLocaleUrl(locale), "/invitationMessage"), { channel: channel, invitationMessage: invitationMessage });
        },
        setCsatSurveyContent: function (locale, content) {
            return http.put("".concat(getLocaleUrl(locale), "/content"), { content: content });
        },
        getDefaultTranslations: function (locale) {
            return http.get("".concat(csatServerUrl, "/translations/").concat(locale));
        },
    };
};
//# sourceMappingURL=index.js.map